import { useHistory } from "react-router";

import { Button } from "@livechat/design-system-react-components";

import { useAgentFlag } from "hooks/use-agent-flag";
import { Tip } from "routes/settings/components/Tip";

import { EmailSettingsRoutes } from "../routes";

import { trackTipClosed, trackTipFollowed } from "./analytics";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const ForwardingAddressesTip = () => {
  const history = useHistory();
  const [, setTipClosed] = useAgentFlag("hasClosedForwardingAddressesTip");

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClick = () => {
    trackTipFollowed();
    history.push(EmailSettingsRoutes.ReplyAddresses);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClose = () => {
    trackTipClosed();
    setTipClosed(true);
  };

  return (
    <Tip onClose={handleClose} dataTestId="forwarding-addresses-tip">
      Want to choose a display name and email address that&apos;s actually visible to customers?{" "}
      <Button onClick={handleClick} kind="link" css={{ fontWeight: "400" }}>
        Set up reply addresses
      </Button>
    </Tip>
  );
};
